import React, { Component, Fragment } from 'react';
import { connect } from 'dva';
import Header from 'components/Header';
import Loading from 'components/Loading';
import styles from './index.less';
import dividerPng from 'images/divider.png';
import { getValue } from 'utils/getValue';
import imgUse from 'images/imgUse.png';
import invalid from 'images/invalid.png';
import router from 'umi/router';
import { getShowTopBar } from '../../utils/getValue';

const languageMap = {
  'zh-cn': {
    Title: '快速安检',
  },
  en: {
    Title: 'CIP',
  },
};
let timer;
@connect(({ cip, loading }) => ({
  loading: loading.effects['cip/cipLogin'],
  cipInfo: cip.cipInfo,
}))
class Cip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isReady: false, // 是否准备就绪
      localActIndex: [], // 网点位置点击的网点的index
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const { query } = this.props.location;
    const { ciphertext, sign } = query;
    if (!ciphertext || !sign) {
      this.getCipInfo();
      return;
    }
    dispatch({
      type: 'cip/cipLogin',
      payload: {
        ciphertext,
        sign,
        ...query,
      },
      callback: () => {
        this.getCipInfo();
      },
    });
  }
  componentWillUnmount() {
    timer && clearTimeout(timer);
  }
  getCipInfo() {
    const { dispatch } = this.props;
    dispatch({
      type: 'cip/getCipInfo',
      callback: (res) => {
        const { flushTime, cip } = res || {};
        console.log(res, 'rrrrrrrr');
        const { cipStatus } = cip || {};
        const isNoNormal = cipStatus === 0 || cipStatus === 1;

        if (flushTime && !isNoNormal) {
          this.getCipFlushQrcode(flushTime);
        }
        this.setState({
          isReady: true,
        });
      },
    });
  }
  getCipFlushQrcode(flushTime) {
    const { dispatch } = this.props;
    timer = setTimeout(() => {
      dispatch({
        type: 'cip/getCipFlushQrcode',
        callback: (res) => {
          this.getCipFlushQrcode(flushTime);
        },
      });
    }, flushTime * 1000);
  }
  // 点击了网点(存在的就删除，不存在的就添加)
  onClickLocal(index) {
    const localActIndex = this.state.localActIndex;
    if (localActIndex.indexOf(index) !== -1) {
      localActIndex.splice(localActIndex.indexOf(index), 1);
    } else {
      localActIndex.push(index);
    }
    this.setState({ localActIndex });
  }
  onRecordClick = () => {
    router.push('/cip/recordList');
  };
  onNetworkClick = () => {
    router.push('/search?netwrokType=cip');
  };
  filterCpupon(coupon = '') {
    let i = 0,
      length = coupon.length,
      str = '';
    while (i < length) {
      str += coupon.slice(i, i + 4);
      str += ' ';
      i = i + 4;
    }
    return str;
  }
  render() {
    const { loading, cipInfo } = this.props;
    const { cip = {}, cipMap = {}, recordList = [], logo } = cipInfo || {};
    const { localActIndex, isReady } = this.state;
    const lg = localStorage.getItem('language') || 'zh-cn';
    const showTopBar = getShowTopBar();
    let title = languageMap[lg].Title;
    const channel = getValue('channel');

    // 网点位置数据
    const pointList = [];
    const showPointBox = channel !== 'bjsh';
    const showExpirDateBox = channel !== 'bjsh';
    // eslint-disable-next-line no-unused-vars
    for (const key in cipMap) {
      pointList.push({ name: key, value: cipMap[key] || [] });
    }
    if (channel === 'bjsh') {
      title = '快速通道服务凭证';
    }
    const isNoNormal = cip.cipStatus === 0 || cip.cipStatus === 1;
    const isHaierChannel = channel === 'haier';
    return (
      <div style={{ opacity: isReady ? 1 : 0 }}>
        <Header title={title} />
        <Loading loading={loading}>
          <div
            className={styles.innerContent}
            style={{
              paddingTop: showTopBar ? '1rem' : '0',
              backgroundColor: '#00622F',
            }}
          >
            <div className={styles.mainBox}>
              {/* cip信息的  0 是失效  1 已使用 */}
              {isNoNormal && (
                <img
                  src={cip.cipStatus === 1 ? imgUse : invalid}
                  alt=""
                  className={styles.useSign}
                />
              )}
              <div className={styles.titleCn}>{`${isHaierChannel ? '' : '龙腾出行·'}快速安检`}</div>
              <div className={styles.titleEn}>{`${isHaierChannel ? '' : 'DragonPass '}`}CIP</div>
              <div className={styles.titleUnderline} />
              {logo && <img className={styles.logo} src={logo} />}
              <div className={styles.cipId}>{this.filterCpupon(cip.cipCoupon)}</div>
              <img src={cip.qrCode} alt="" className={styles.qrCode} />
              <div className={styles.buttonList}>
                <div className={styles.button} onClick={this.onRecordClick}>
                  消费记录
                </div>
                <div className={styles.button} onClick={this.onNetworkClick}>
                  可用网点
                </div>
              </div>
              <img src={dividerPng} alt="" className={styles.dividerPng} />
              <ul className={styles.cipInfo}>
                {showPointBox && (
                  <li>
                    <div className={styles.left}>
                      <div>发券机构</div>
                      <div>Issuer</div>
                    </div>

                    <span className={styles.right}>{cip.couponCompany}</span>
                  </li>
                )}
                <li>
                  <div className={styles.left}>
                    <div>可用人数</div>
                    <div>Time Value</div>
                  </div>
                  <span className={styles.right}>{cip.peopleNum || 0}人次</span>
                </li>
                {showExpirDateBox && (
                  <li>
                    <div className={styles.left}>
                      <div>有效期至</div>
                      <div>Validity</div>
                    </div>

                    <span className={styles.right}>{cip.endTime}</span>
                  </li>
                )}
              </ul>
              {/* <div className={styles.divider} /> */}
              <div className={styles.otherMsg}>
                <div>使用须知</div>
                <div className={styles.know}>
                  1.请至少在您所乘坐航班关闭舱门前25分钟使用，无须预约，在接待位置出示使用凭证即可。
                  <br />
                  2.CIP通道服务为不记名使用产品，请妥善保管您的凭证信息。
                  <br />
                  3.两周岁以下的儿童可免费使用。
                </div>
                <div>
                  DragonPass reserves the right to amend or withdraw this programme at its sole
                  discretion
                </div>
              </div>
            </div>
          </div>
        </Loading>
      </div>
    );
  }
}

export default Cip;
